import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontSize: 12,
    fontFamily: ['Pt Sans', 'sans-serif'].join(','),
    allVariants: {
      fontFamily: ['Pt Sans', 'sans-serif'].join(','),
      fontSize: 16,
    },
  },
  palette: {
    primary: {
      main: '#1F9ECC',
    },
    warning: {
      main: '#fcdb93',
    },
    error: {
      main: '#d61633',
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginLeft: 0,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.MuiIconButton-sizeMedium': {
            marginRight: '-10px;',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: {
          '&.MuiOutlinedInput-input': {
            padding: 0,
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000', // Borda padrão
          },
          '&.MuiInputBase-colorWarning fieldset': {
            borderColor: '#fcdb93',
          },
        },
      },
    },
  },
});
